import { ExModule } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const storage = sessionStorage.getItem("inputFilter")
  ? JSON.parse(sessionStorage.getItem("inputFilter") || "")
  : null;

const event: State = {
  eventId: storage?.eventId || 0,
  eventStartDate: storage?.eventStartDate || "",
  eventEndDate: storage?.eventEndDate || "",
  eventPeriod: storage?.eventPeriod || "week",
  eventShowCategory: storage?.eventShowCategory || "0"
};

const official: State = {
  officialStartDate: storage?.officialStartDate || "",
  officialEndDate: storage?.officialEndDate || "",
  officialShowCategory: storage?.officialShowCategory || "0",
  officialPeriod: storage?.officialPeriod || "week"
};

const scout: State = {
  scoutTemplateId: storage?.scoutTemplateId || 0,
  scoutStartDate: storage?.scoutStartDate || "",
  scoutEndDate: storage?.scoutEndDate || "",
  scoutShowCategory: storage?.scoutShowCategory || "0",
  scoutPeriod: storage?.scoutPeriod || "week"
};

const state: State = { ...event, ...official, ...scout };

const PerformancesModule: ExModule<State, Actions, Getters, Mutations> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default PerformancesModule;
